import * as React from 'react';
import { FieldProps } from './props';
import api from '../../../api';
import './autocomplete.scss';
import { VisibilityGroup } from '../../../core';
import { isObject } from 'util';
import { UserAvatar } from '../../render-file/UserAvatar';

const VisibilityGroupInput: React.FunctionComponent<FieldProps> = (props) => {
  const [list, setList] = React.useState<VisibilityGroup[]>(
    !!props.defaultValue?.length
      ? props.data?.filter((s) => !!props.defaultValue?.includes(s._id))
      : props.data
  );
  const [allList, setAllList] = React.useState<VisibilityGroup[]>(props.data);
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<
    VisibilityGroup[] | undefined
  >();

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    if (!!props.data?.length) {
      const selected = !!props.defaultValue?.length
        ? props.data?.filter((s) => !!props.defaultValue?.includes(s._id))
        : [];
      const listItems = !!props.defaultValue?.length
        ? props.data?.filter((s) => !props.defaultValue?.includes(s._id))
        : props.data;
      setSelectedItem(selected);
      setList(listItems);
      setAllList(props.data);
    }
  }, [props.data, props.defaultValue]);

  const clickDropDown = () => {
    if (props.disabled) {
      return;
    }

    setShowDropDown(!showDropDown);
  };

  const handleSelect = (item: VisibilityGroup) => {
    const vgList = list?.length ? [...list] : [];

    setList(vgList?.filter((x) => x._id !== item._id));
    const selected = selectedItem?.length ? [...selectedItem] : [];
    selected.push(item);
    setSelectedItem(selected);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(selected);
    }
  };

  const onRemove = (item: VisibilityGroup) => {
    const selected = selectedItem?.filter((x) => x._id !== item._id) || [];
    setList(allList?.filter((x) => !!selected?.find((s) => s._id === x._id)));

    setSelectedItem(selected);

    if (props.onChange != null) {
      props.onChange(selected);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  return (
    <React.Fragment>
      {props.label && <label className={props.labelClass}>{props.label}</label>}
      <div
        className="custom-dropdown position-relative"
        style={{ maxWidth: props.sm ? '450px' : '' }}
        ref={wrapperRef}
      >
        <div
          onClick={clickDropDown}
          className="custom-dropdown__value border rounded-sm font-normal d-flex align-items-center font-weight-semibold cursor-pointer bg-white"
        >
          <div
            className="flex-fill d-flex flex-wrap"
            style={{ lineHeight: props.sm ? '20px' : '28px' }}
          >
            {!!selectedItem?.length ? (
              <>
                {selectedItem?.map((item) => {
                  return (
                    <span className="bg-gray-300 border mr-1 pl-1 pr-1">
                      {item.title}{' '}
                      <i
                        className="icon-close font-xxxs font-weight-semibold ml-1"
                        onClick={() => onRemove(item)}
                      ></i>{' '}
                    </span>
                  );
                })}
              </>
            ) : (
              <>Select Visibility Group</>
            )}
          </div>
          {(!selectedItem || !props.defaultValue || !props.onReset) && (
            <i className="icon-chevron-down ml-auto"></i>
          )}
          {selectedItem && props.defaultValue && props.onReset && (
            <i
              onClick={() => {
                setSelectedItem(undefined);
                props.onReset?.();
              }}
              className="icon-close ml-auto"
            ></i>
          )}
        </div>
        {showDropDown && !props.disabled && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-9 pt-0">
            {list?.map((item) => {
              return (
                <div
                  onClick={() => handleSelect(item)}
                  className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
                >
                  <div className="col gutter-10 pr-0 row sales-person align-items-center">
                    <div className="col-xl-12 col-12 pl-0 d-flex align-items-center flex-wrap">
                      <>
                        <div className="d-inline-block font-normal font-weight-semibold">
                          {item?.title}
                        </div>
                        {!!item?.parents?.length && (
                          <div className="d-block font-xxxs text-gray-500 w-100">
                            {item?.parents?.map((p, index) => {
                              const vg = allList?.find((v) => v._id === p);
                              return (
                                <>
                                  {vg?.title}
                                  {item?.parents?.length > index + 1 && (
                                    <>{'>'}</>
                                  )}
                                </>
                              );
                            })}
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default VisibilityGroupInput;
